// Row component used by the mapping function in PartsTable.js
import React from 'react';


function PartsRow({partsx}) {
    
    return (
  
            <tr>
                <td className='type-web'>{partsx.type}</td>
                <td className='web-link' > <a href={`${partsx.px_link}`} target='_blank' rel="noopener noreferrer">
                    View Link
                    </a> 
                    </td>
               
            </tr> 
            
    );
} 

export default PartsRow;